import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { sendBannerClickEvent } from "../../commons/banner";
import { LanderConfig } from "../../types/LanderConfig";

interface GetDomainButtonProps {
  landerConfig: LanderConfig;
  className?: string;
}

export default function GetDomainButton({
  landerConfig,
  className,
}: GetDomainButtonProps): ReactElement | null {
  const link = landerConfig.lander?.banner?.link;
  if (!link) return null;
  const bannerType = landerConfig?.lander?.banner?.type;
  return (
    <a
      className={ className }
      href={ link }
      onClick={ () => sendBannerClickEvent(bannerType, landerConfig) }
    >
      <FormattedMessage id="GetThisDomainCTA" />
    </a>
  );
}
